import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { TemplateBuilder } from '@/features/hr-performance/template-builder'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the scorecard template builder (plans/16 Task 18).
 *
 * The grant guard lives in `beforeLoad`, as `apps/company/AGENTS.md` requires;
 * the API enforces `performance_template.view` regardless.
 */
export const Route = createFileRoute('/_authenticated/hr/performance/templates')({
  validateSearch: z.object({ showHidden: z.boolean().optional() }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'performance_template.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: TemplateBuilderRoute,
})

function TemplateBuilderRoute() {
  return <TemplateBuilder />
}
